import type { TemplateBlock } from './types';

export const styleOfSection: Record<TemplateBlock['type'], 'row' | 'column'> = {
  button: 'row',
  image: 'column',
  textarea: 'column',
  'rating-star': 'column',
};
